<script lang="ts">
  import type { User } from '@bond/bruce-api/common/user'
  import type { LayoutData } from './$types'
  import { browser } from '$app/environment'
  import { LOCALES } from '$lib/constants/lang'
  import { page } from '$app/stores'
  import { DEFAULT_META, META_TITLE_SUFFIX } from '$lib/constants/meta'
  import * as Sentry from '@sentry/browser'
  import { utils } from '$lib/utils'
  import { PUBLIC_BRUCE_PUBLIC_SITE_TLD } from '$env/static/public'

  export let data: LayoutData

  $: ({ user, alternateLocales, alternateLanguages, lang, url, hasAlternates } =
    data)

  $: identifySentryUser(user)

  if (
    browser &&
    location.hostname === `www.${PUBLIC_BRUCE_PUBLIC_SITE_TLD}` &&
    !utils.theme.get()
  ) {
    if (document.documentElement.hasAttribute('dark-theme')) {
      utils.theme.set('dark')
    } else {
      utils.theme.set('light')
    }
  }

  function identifySentryUser(user: User | undefined) {
    if (user?.email) {
      Sentry.setUser({ email: user.email })
    }
  }
</script>

<svelte:head>
  <title
    >{$page.data.title || DEFAULT_META[lang].TITLE}{META_TITLE_SUFFIX}</title
  >
  <meta
    name="description"
    content={$page.data.description || DEFAULT_META[lang].DESCRIPTION}
  />
  <meta
    property="og:title"
    content="{$page.data.title || DEFAULT_META[lang].TITLE}{META_TITLE_SUFFIX}"
  />
  <meta
    property="og:description"
    content={$page.data.description || DEFAULT_META[lang].DESCRIPTION}
  />
  <meta
    name="twitter:title"
    content="{$page.data.title || DEFAULT_META[lang].TITLE}{META_TITLE_SUFFIX}"
  />
  <meta
    name="twitter:description"
    content={$page.data.description || DEFAULT_META[lang].DESCRIPTION}
  />
  <meta property="og:locale" content={LOCALES[lang]} />
  {#if hasAlternates}
    {#each alternateLocales as locale (locale)}
      <meta property="og:locale:alternate" content={locale} />
    {/each}
    {#each alternateLanguages as language (language)}
      <link
        rel="alternate"
        hreflang={language}
        href={url.replace(`/${lang}`, `/${language}`)}
      />
    {/each}
  {/if}
</svelte:head>
<slot />
